import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Col, Row } from 'react-grid-system';
import H1 from '../../atoms/title/H1';
import Panel from '../../atoms/Panel';
import Layout from '../../templates/Layout';
import H3 from '../../atoms/title/H3';
import Paragraph from '../../atoms/Paragraph';
import Checkboxes from '../../molecules/form/report/Checkboxes';
import Filters from '../../molecules/form/report/Filters';
import Frequency from '../../molecules/form/report/Frequency';
import Flex from '../../atoms/Flex';
import { Helmet } from 'react-helmet';
import InputItem from '../../molecules/InputItem';
import { useForm } from '@inertiajs/react';
import Button from '../../atoms/Button';
import Notice from '../../molecules/Notice';
/**
 * json object containing selected filters
 *
 * @todo define props
 */
export class ExportFilters {
}
export class CreateExportFormData {
    /** name of the export */
    label = '';
    /**
     * expression for frequency
     * @deprecated replaced by frequency object
     * @todo remove this
     */
    expression = '';
    /**  */
    frequency = { period: 'once', day_of_month: '', day_of_week: '', time_of_day: '' };
    /** option to receive notifications when export is ready */
    receive_notifications = false;
    /** json object containing selected filters */
    filters = new ExportFilters();
    /** names of columns to export */
    export_columns = [];
    constructor(availableColumns) {
        this.export_columns = Object.keys(availableColumns);
    }
}
const Create = ({ availableColumns = {}, availableFilters = {}, }) => {
    const { data, setData, post, processing, errors, recentlySuccessful, } = useForm(new CreateExportFormData(availableColumns));
    const [errorNotice, setErrorNotice] = useState(null);
    const handleSubmit = (e) => {
        e.preventDefault();
        try {
            post(window.location.href);
        }
        catch (e) {
            setErrorNotice('Rapportage kon niet worden aangemaakt. Probeer het later nogmaals.');
        }
    };
    return (_jsxs(Layout, { "data-testid": "report-create", children: [_jsx(Helmet, { children: _jsx("title", { children: "Rapportage aanmaken" }) }), _jsx(H1, { "data-testid": "title", children: "Rapportage aanmaken" }), _jsx("form", { action: "./", method: "post", onSubmit: handleSubmit, children: _jsxs(Panel, { children: [recentlySuccessful && (_jsx(Notice, { type: 'success', text: 'Nieuwe rapportage is aangemaakt', title: 'Rapportage aangemaakt' })), errorNotice && (_jsx(Notice, { type: 'error', text: errorNotice || '', title: 'Fout' })), _jsxs(Row, { children: [_jsxs(Col, { sm: 6, children: [_jsx(H3, { children: "Stel je rapportage samen" }), _jsx(InputItem, { label: "Naam van de rapportage", onChange: e => setData('label', e.target.value), error: errors?.label, required: true }), _jsx(Paragraph, { children: "Selecteer de gewenste gegevens" }), _jsx(Checkboxes, { availableColumns, data, setData, errors })] }), _jsxs(Col, { sm: 6, children: [_jsx(H3, { children: "Filters" }), _jsx(Filters, { availableFilters, data, setData, errors }), _jsxs(Flex, { column: true, margin: "45px 0 0 0", children: [_jsx(H3, { children: "Frequentie" }), _jsx(Frequency, { data, setData, errors })] })] })] }), _jsx(Flex, { justifyContent: "flex-end", children: _jsx(Button, { type: "submit", secondary: true, isLoading: processing, children: "Aanmaken" }) })] }) })] }));
};
export default Create;
